import React, { Component } from "react"
import PropTypes from "prop-types"
import Icon from "@kit/design/icon"
import "./dropdown-item.css"

export class DropdownItem extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    href: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func
  }

  render() {
    const { children, href, icon, onClick, ...props } = this.props

    return (
      <a
        {...props}
        href={href}
        onClick={onClick}
        className="core-dropdown-item"
      >
        {this.props.icon && (
          <Icon className="core-dropdown-item__icon" name={icon} />
        )}
        {children}
      </a>
    )
  }
}
